import { useState, useEffect, useRef } from 'react'

const AUTO_RETRY_MAX = 10
const AUTO_RETRY_INTERVAL = 10

export function useAutoRetry(isError: boolean, refetch: () => void) {
  const [autoRetryCount, setAutoRetryCount] = useState(0)
  const [autoRetryCountdown, setAutoRetryCountdown] = useState(0)
  // Zabrání resetu počítadla když isError dočasně zmizí během načítání retrye
  const isRetrying = useRef(false)

  useEffect(() => {
    if (!isError) {
      if (!isRetrying.current) {
        setAutoRetryCount(0)
        setAutoRetryCountdown(0)
      }
      isRetrying.current = false
      return
    }
    if (autoRetryCount >= AUTO_RETRY_MAX) return
    setAutoRetryCountdown(AUTO_RETRY_INTERVAL)
    const interval = setInterval(() => {
      setAutoRetryCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval)
          isRetrying.current = true
          setAutoRetryCount(c => c + 1)
          refetch()
          return 0
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(interval)
  }, [isError, autoRetryCount])

  const resetAndRetry = () => {
    isRetrying.current = false
    setAutoRetryCount(0)
    refetch()
  }

  return { autoRetryCount, autoRetryCountdown, maxRetries: AUTO_RETRY_MAX, resetAndRetry }
}
